import agent from '../agent'
import { addCommentToCommentsList, topicStanceCommentToCommentList, deleteCommentToCommentsList, topicStanceDeleteCommentToCommentsList, replaceCommentToCommentsList,topicStanceReplaceCommentToCommentsList } from './commentsList';
import {
  COMMENT_CREATED,
    TOPIC_STANCE_COMMENT_CREATED,
  COMMENTS_LOADED,
  COMMENTS_UNLOADED,
    TOPIC_STANCE_COMMENTS_UNLOADED,
    TOPIC_STANCE_COMMENTS_LOADED
} from "../constants/actionTypes"
import {appLoadSuccess} from "./main";

export const commentCreated = (payload) => ({
  type: COMMENT_CREATED,
  payload
})
export const topicStanceCommentCreated = (payload) => ({
  type: TOPIC_STANCE_COMMENT_CREATED,
  payload
})

export const createComment = (dispatch, getState) => (postId, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    const token = window.localStorage.getItem('bearerToken');
    agent.Comments.create(postId, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
    dispatch(commentCreated(res));
    loadComments(dispatch, getState)(postId)
        agent.Auth.current().then(resp => {
            dispatch(appLoadSuccess({ res:resp, token, skipTracking: true }));
        }).catch(error => {
            console.log(error)
        })
  }, err => {
    dispatch(commentCreated(err));
  })
}

export const topicStanceCreateComment = (dispatch, getState) => (topicStanceId, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    const token = window.localStorage.getItem('bearerToken');
    agent.Comments.topicStanceCreate(topicStanceId, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
        dispatch(topicStanceCommentCreated(res));
        topicStanceLoadComments(dispatch, getState)(topicStanceId)
        agent.Auth.current().then(resp => {
            dispatch(appLoadSuccess({ res:resp, token, skipTracking: true }));
        }).catch(error => {
            console.log(error)
        })
    }, err => {
        dispatch(topicStanceCommentCreated(err));
    })
}

export const createReplyComment = (dispatch, getState) => (postId, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    agent.Comments.createReply(postId, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
        dispatch(commentCreated(res));
        loadReplyComments(dispatch, getState)(postId, commentId)
    }, err => {
        dispatch(commentCreated(err));
    })
}

export const topicStanceCreateReplyComment = (dispatch, getState) => (topicStanceId, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    agent.Comments.topicStanceCreateReply(topicStanceId, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
        dispatch(topicStanceCommentCreated(res));
        topicStanceLoadReplyComments(dispatch, getState)(topicStanceId, commentId)
    }, err => {
        dispatch(topicStanceCommentCreated(err));
    })
}

export const commentsLoaded = (payload) => ({
  type: COMMENTS_LOADED,
  payload
})

export const topicStanceCommentsLoaded = (payload) => ({
  type: TOPIC_STANCE_COMMENTS_LOADED,
  payload
})

export const commentsUnloaded = () => ({
  type: COMMENTS_UNLOADED
})

export const topicStanceCommentsUnloaded = () => ({
  type: TOPIC_STANCE_COMMENTS_UNLOADED
})

export const loadComments = (dispatch, getState) => (postId) => {
  agent.Comments.forPost(postId).then(res => {
    dispatch(commentsLoaded(res));
    let store = getState();
    if (store && store.comments && store.comments.comment) {
      let newComment = res.find(item => item.id === store.comments.comment.id)
      addCommentToCommentsList(dispatch, getState)(newComment);
    }
  }, err => {
    dispatch(commentsLoaded(err));
  })
}

export const topicStanceLoadComments = (dispatch, getState) => (topicStanceId) => {
  agent.Comments.forTopicStance(topicStanceId).then(res => {
    dispatch(topicStanceCommentsLoaded(res));
    let store = getState();
    if (store && store.comments && store.comments.topicStanceComment) {
      let newComment = res.find(item => item.id === store.comments.topicStanceComment.id)
        topicStanceCommentToCommentList(dispatch, getState)(newComment);
    }
  }, err => {
    dispatch(topicStanceCommentsLoaded(err));
  })
}

export const deleteComments = (dispatch, getState) => (id) => {
            deleteCommentToCommentsList(dispatch, getState)(id);
}

export const topicStanceDeleteComments = (dispatch, getState) => (id) => {
            topicStanceDeleteCommentToCommentsList(dispatch, getState)(id);
}

export const topicStanceDeleteFullPageComments = (dispatch, getState) => (id) => {
    let store = getState();
    let commentsList = store.comments.topicStanceComments
    let newCommentList= commentsList.filter(i => i.id !== id)
    dispatch(topicStanceCommentsLoaded(newCommentList));
}

export const loadReplyComments = (dispatch, getState) => (postId, commentId) => {
    agent.Comments.forPost(postId).then(res => {
        dispatch(commentsLoaded(res));
        let store = getState();
        if (store && store.comments && store.comments.comment) {
            let newComment = res.find(item => item.id === commentId)
            replaceCommentToCommentsList(dispatch, getState)(newComment);
        }
    }, err => {
        dispatch(commentsLoaded(err));
    })
}
export const topicStanceLoadReplyComments = (dispatch, getState) => (topicStanceId, commentId) => {
    agent.Comments.forTopicStance(topicStanceId).then(res => {
        dispatch(topicStanceCommentsLoaded(res));
        let store = getState();
        if (store && store.comments && store.comments.topicStanceComment) {
            let newComment = res.find(item => item.id === commentId)
            topicStanceReplaceCommentToCommentsList(dispatch, getState)(newComment);
        }
    }, err => {
        dispatch(topicStanceCommentsLoaded(err));
    })
}
export const unloadComments = (dispatch) => () => {
  dispatch(commentsUnloaded());
}

export const topicStanceUnloadComments = (dispatch) => () => {
  dispatch(topicStanceCommentsUnloaded());
}

